(() => {
  const items = document.querySelectorAll('.collection-card-item');
  if (!items) {
    return;
  }

  items.forEach((item) => {
    const title = item.getAttribute('data-title');
    const searchQuery = item.getAttribute('data-search');

    // Normalize both strings by removing accents, so accented strings are also picked by search query. E.g. retez -> řetěz
    const normalizedTitle = title.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    const normalizedSearchQuery = searchQuery.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

    // items are hidden by default, show only ones that contain the search string
    if (normalizedTitle.includes(normalizedSearchQuery)) {
      item.style.display = 'block';
    }
  });
})();
